import { setCookie } from "@utils/localStorageUtil";
import { ls_permissionList, ls_permissionList_new } from "@/dataBase/localStorageKeys";
import { getUserInfo, getUserInfoNew, getBId, getOrgInfo, getComtyId, getComtyIdNew, getComtyInfoNew, setBId, setComtyId, setComtyIdNew, setComtyIdToken, setComtyInfo, setComtyInfoNew, setUserInfo, setUserInfoNew, setOrgInfo, getToken, getTokenNew, setIsAuth, getIsAuth } from "@/utils/userStorage";
import authCodeMap from "@/dataBase/authCodeMap";
import service from "@/commonService/index";
import { sortTree, shakeTree, allChild, deleteNode } from "@/utils/commonUtil";
import commonService from "@/commonService";
import { walkArray } from "@/utils/commonUtil";
import { temPermissions } from "@/utils/temPermission";
// import { ActionContext } from "vuex";
const token = getToken();
const tokenNew = getTokenNew();
const userInfo = token ? getUserInfo() || "" : "";
const userInfoNew = tokenNew ? getUserInfoNew() || "" : "";
// const comtyInfo = getCookie(ls_comtyInfo);
const bId = token ? getBId() || "" : "";
const orgInfo = token ? getOrgInfo() || "" : "";
const comtyId = token ? getComtyId() || "" : "";
const comtyIdNew = tokenNew ? getComtyIdNew() || "" : "";
const isHaveAuth = token ? getIsAuth() || null : null;
// const permissionList = getCookie(ls_permissionList);
// import logger from "@wenwo-public/shence-logger-js";
// 广告位的数据约束
export interface advertFields {
  bannerUrl: string; // 图片URL
  communityId: string; // 社区id
  configType: "INDEX_PAGE" | "HEALTH_CIRCLE" | "ARTICLE_DETAILS" | "POST_DETAILS" | "SHARE_DETAILS"; // 广告配置类型
  content: string; // 广告内容
  height: string; // 广告位高度
  id: string;
  linkUrl: string; // 跳转url
  name: string; // 姓名
  remarks: string; // 说明
  sort: number; // 排序
  tip: string; // 悬停说明
  jumpLinkType: "COMMUNITY_CONTENT" | "EXTERNAL_LINK"; // 跳转类型
}
function controlleMeau(npermission: any, state: any) {
  // 如果不是在白名单的社区id，在侧边栏不展示身高测评,白名单用户才可以看见身高测评
  // console.error(process.env.VUE_APP_COMTY_ID, "...process.env.VUE_APP_COMTY_ID..");
  let whiteList = (process.env.VUE_APP_COMTY_ID as string).indexOf("|") > -1 ? (process.env.VUE_APP_COMTY_ID as string).split("|") : [process.env.VUE_APP_COMTY_ID]; // [process.env.VUE_APP_COMTY_ID];
  whiteList = whiteList.map((item: any) => item.trim());
  console.warn(whiteList, ".whiteList..", state.comtyId);
  if (!whiteList.includes(state.comtyId)) {
    deleteNode(npermission, (listItem: any) => listItem.permissionFlag === authCodeMap.operationTools_measurementHeight);
  }
}
function setAreaOptions(areaOptions: any) {
  walkArray(areaOptions, (item: any) => {
    if (item.list.length === 0) {
      item.list = null;
    }
    if (item.list && item.list.length > 0) {
      setAreaOptions(item.list);
    }
  });
}

// mutationTypes
export const SET_ADVERT_DATAS = "setAdvertDatas";
const main = {
  state: {
    userInfo: userInfo ? userInfo : {},
    orgInfo: orgInfo ? orgInfo : {},
    comtyId: comtyId ? comtyId : "",
    isEverSetStateGeneService: 0,
    comtyInfo: { communityId: "", auditStatus: "", annualStatus: "", expireStatus: "", expireSource: "" },
    bId: bId || "",
    comtyConfig: { settledAudit: "" },
    permissionList: "",
    currentRouteName: "",
    messageNumber: -1,
    messageNumberNew: -1,
    pagePermissionList: "",
    advertGroup: [], // 广告管理首页的数据
    isOrgAuth: isHaveAuth, // 是否开启预约通和是否开启语音播报
    version: "v1", // v1 旧社区,v2 新社区
    comtyIdNew: comtyIdNew ? comtyIdNew : "",
    comtyInfoNew: getComtyInfoNew() || { communityId: "", auditStatus: "", annualStatus: "", expireStatus: "", expireSource: "" },
    permissionListNew: "",
    pagePermissionListNew: "",
    userInfoNew: userInfoNew ? userInfoNew : {},
    comtyIdToken: "",
    isBudgetSystem: null,
    tabNum: {},
    searchItem_Inited: false,
    searchItem_placeCode: {
      label: "所在地区：",
      key: "placeCode",
      type: "cascader",
      placeHolder: "全部",
      clearable: true,
      cascaderOptions: [],
      size: "small",
      props: {
        children: "list",
        label: "dictValue",
        value: "dictCode",
        checkStrictly: true,
      },
      style: { width: "220px" },
    },
    isBudgetHealthProjectAtivitySystemPermission: null,
  },
  getters: {
    isLogin: (state: any) => {
      return !!(state.userInfo && state.userInfo.id);
    },
  },
  mutations: {
    SET_isBudgetSystem(state: any, isBudgetSystem: boolean) {
      state.isBudgetSystem = isBudgetSystem;
    },
    SET_isBudgetHealthProjectAtivitySystemPermission(state: any, isBudgetHealthProjectAtivitySystemPermission: boolean) {
      state.isBudgetHealthProjectAtivitySystemPermission = isBudgetHealthProjectAtivitySystemPermission;
    },
    SET_searchItem_placeCode(state: any, searchItem_placeCode: any) {
      state.searchItem_placeCode = searchItem_placeCode;
    },
    searchItem_Inited(state: any, searchItem_Inited: any) {
      state.searchItem_Inited = searchItem_Inited;
    },
    SET_ORG_AUTH(state: any, isOrgAuth: boolean) {
      setIsAuth(isOrgAuth);
      state.isOrgAuth = isOrgAuth;
    },
    SET_PagePermissionList(state: any, pagePermissionList: any) {
      state.pagePermissionList = pagePermissionList;
    },
    SET_PagePermissionListNew(state: any, pagePermissionListNew: any) {
      state.pagePermissionListNew = pagePermissionListNew;
    },
    SET_CurrentRouteName(state: any, currentRouteName: string) {
      state.currentRouteName = currentRouteName;
    },
    SET_USERINFO(state: any, userInfo: any) {
      setUserInfo(userInfo);
      state.userInfo = userInfo;
    },
    SET_USERINFONEW(state: any, userInfo: any) {
      setUserInfoNew(userInfo);
      state.userInfoNew = userInfo;
    },
    SET_BID(state: any, bId: Number | String) {
      setBId(bId);
      state.bId = bId;
    },
    SET_COMTYID(state: any, comtyId: Number | String) {
      setComtyId(comtyId);
      state.comtyId = comtyId;
    },
    SET_COMTYIDNEW(state: any, comtyId: Number | String) {
      setComtyIdNew(comtyId);
      state.comtyIdNew = comtyId;
    },
    SET_COMTYITOKEN(state: any, token: String) {
      setComtyIdToken(token);
      state.comtyIdToken = token;
    },
    SET_ORGINFO(state: any, orgInfo: Object) {
      setOrgInfo(orgInfo);
      state.orgInfo = orgInfo;
    },
    SET_PERMISSIONLIST(state: any, permissionList: any) {
      setCookie(ls_permissionList, permissionList);
      state.permissionList = permissionList;
    },
    SET_PERMISSIONLISTNEW(state: any, permissionList: any) {
      setCookie(ls_permissionList_new, permissionList);
      state.permissionListNew = permissionList;
    },
    SET_COMTYINFO(state: any, comtyinfo: any) {
      setComtyInfo(comtyinfo);
      state.comtyInfo = comtyinfo;
    },
    SET_COMTYINFONEW(state: any, comtyinfo: any) {
      setComtyInfoNew(comtyinfo);
      state.comtyInfoNew = comtyinfo;
    },
    SET_COMTYCONFIG(state: any, comtyConfig: any) {
      state.comtyConfig = comtyConfig;
    },
    SET_MESSAGENUMBER(state: any, messageNumber: any) {
      // console.log(12312312312312);
      state.messageNumber = messageNumber;
    },
    SET_MESSAGENUMBERNEW(state: any, messageNumber: any) {
      // console.log(12312312312312);
      state.messageNumberNew = messageNumber;
    },
    SET_TABNUM(state: any, tabNum: any) {
      // console.log(12312312312312);
      state.tabNum = tabNum;
    },
    SET_ADVERT_DATAS: (state: any, payload: Array<advertFields>) => {
      console.log("111111111");
      state.advertGroup = payload;
    },
    SET_VERSION(state: any, version: any) {
      // console.log(12312312312312);
      state.version = version;
    },
    SET_isEverSetStateGeneService(state: any, version: any) {
      // console.log(12312312312312);
      state.isEverSetStateGeneService = version;
    },
  },
  actions: {
    async GET_searchItem({ commit }: any, communityId: String) {
      const res = await commonService.getDictionaryTree({
        dictParentId: 0,
        dictType: "MAP",
      });
      if (res.code == 200 && res.data) {
        setAreaOptions(res.data);
        commit("SET_searchItem_placeCode", {
          label: "所在地区：",
          key: "placeCode",
          type: "cascader",
          placeHolder: "全部",
          clearable: true,
          cascaderOptions: res.data,
          size: "small",
          props: {
            children: "list",
            label: "dictValue",
            value: "dictCode",
            checkStrictly: true,
          },
          style: { width: "220px" },
        });
      }
      commit("searchItem_Inited", true);
    },
    GET_PagePermissionList({ commit, state }: any) {
      const all: any = [];
      allChild(state.permissionList, all);
      // console.log("这是全部", all);
      commit("SET_PagePermissionList", all);
    },
    GET_PERMISSIONLIST({ commit, dispatch, state }: any) {
      const pp = service.getSysMenuByCommunity({}).then((res: any) => {
        if (res.code == 200 && res.data) {
          let reqPermission: any[] = [];
          if (!(state.comtyInfo.enableDoctorCommunity == 1 && state.comtyInfo.enablePatientCommunity == 1) || state.comtyInfo.version === "v2") {
            reqPermission = [
              {
                menuName: "社区",
                permissionFlag: "top_community",
                sortNo: 1,
                type: "menu",
                children: res.data,
              },
            ];
          } else {
            reqPermission = res.data;
          }
          const permission: any[] = [];
          sortTree(reqPermission, permission);
          console.log("sortTree", permission);
          const npermission = shakeTree(permission);
          controlleMeau(npermission, state);

          // console.log("controlleMeau", npermission);
          commit("SET_PERMISSIONLIST", npermission);
          dispatch("GET_PagePermissionList");
          // commit(types.SET_PERMISSIONLOADED, true);
        }
      });
      return pp;
    },
    UPDATE_USERINFO({ commit }: any, token: String) {
      return service.myinfo({ token: token }).then((res: any) => {
        console.log("UPDATE到了用户信息", res);
        if (res.code == 200 && res.data) {
          const userinfo = res.data;
          // logger.login(userinfo.id as string, {});
          commit("SET_USERINFO", userinfo);
          return userinfo;
        }
      });
    },
    GET_ORGINFO({ commit }: any) {
      return service.queryOrgDetail({}).then((res: any) => {
        // console.log("UPDATE到了用户信息");
        if (res.code == 200 && res.data) {
          const orginfo = res.data;
          commit("SET_BID", orginfo.id);
          commit("SET_ORGINFO", orginfo);
          service.orgAuthority({ orgId: orginfo.id }).then((result: any) => {
            const isAuth = result.data.authority;
            console.error(result, isAuth, "resultresult");
            commit("SET_ORG_AUTH", isAuth);
          });
          return orginfo;
        }
      });
    },
    UPDATE_COMTYINFO({ commit }: any, communityId: String) {
      return service
        .getCommunityDetail({
          communityId,
        })
        .then((res: any) => {
          if (res.code == 200 && res.data) {
            const comtyinfo = res.data;
            commit("SET_COMTYINFO", comtyinfo);
            return Promise.resolve(res);
          }
        });
    },
    UPDATE_COMTYCONFIG({ commit }: any, communityId: String) {
      return service
        .getCommunityConfig({
          communityId,
        })
        .then((res: any) => {
          if (res.code == 200 && res.data) {
            const comtyConfig = res.data;
            commit("SET_COMTYCONFIG", comtyConfig);
          }
        });
    },
    UPDATE_MESSAGENUMBER({ commit }: any, communityId: String) {
      return service
        .getUnReadMessageNumber({
          communityId,
        })
        .then((res: any) => {
          if (res.code == 200) {
            const messageNumber = res.data;
            commit("SET_MESSAGENUMBER", messageNumber);
          }
        });
    },
    UPDATE_MESSAGENUMBERNEW({ commit }: any, communityId: String) {
      return service
        .findMessageList({
          communityId,
          pageSize: 10,
          pageNum: 1,
          readStatus: false,
        })
        .then((res: any) => {
          if (res.code == 200) {
            const messageNumber = res.data.total || 0;
            commit("SET_MESSAGENUMBERNEW", messageNumber);
          }
        });
    },
    UPDATE_TABNUM({ commit }: any, communityId: String) {
      return service
        .getBubbleData({
          communityId,
        })
        .then((res: any) => {
          if (res.code == 200) {
            const _obj: any = {};
            for (let i = 0; i < res.data.length; i++) {
              _obj[res.data[i].type] = res.data[i].bubbleNumber;
            }
            commit("SET_TABNUM", _obj);
          }
        });
    },

    UPDATE_VERSION({ commit }: any, version: String) {
      commit("SET_VERSION", version);
    },
    async UPDATE_isEverSetStateGeneService({ commit }: any, communityId: String) {
      const res = await service.isEverSetStateByCommunityId({
        communityId,
      });
      if (res.code == 200 && res.data) {
        const setInfo = res.data;

        commit("SET_isEverSetStateGeneService", setInfo);
        return res;
      }
    },
    async UPDATE_COMTYINFONEW({ commit }: any, communityId: String) {
      const res = await service.getCommunityDetail({
        communityId,
      });
      if (res.code == 200 && res.data) {
        const comtyinfo = res.data;

        commit("SET_COMTYINFONEW", comtyinfo);
        return res;
      }
    },
    GET_PagePermissionListNEW({ commit, state }: any) {
      const all: any = [];
      allChild(state.permissionListNew, all);
      // console.log("这是全部", all);
      commit("SET_PagePermissionListNew", all);
    },
    GET_PERMISSIONLISTNEW({ commit, dispatch, state }: any) {
      const pp = service.getSysMenuByCommunity({}).then((res: any) => {
        if (res.code == 200 && res.data) {
          let reqPermission: any[] = [];
          if (!(state.comtyInfo.enableDoctorCommunity == 1 && state.comtyInfo.enablePatientCommunity == 1) || state.comtyInfo.version === "v2") {
            reqPermission = [
              {
                menuName: "社区",
                permissionFlag: "top_community",
                sortNo: 1,
                type: "menu",
                children: res.data,
              },
            ];
          } else {
            reqPermission = res.data;
          }
          const permission: any[] = [];
          sortTree(reqPermission, permission);
          // console.log("sortTree", permission);
          const npermission = shakeTree(permission);
          controlleMeau(npermission, state);

          // console.log("controlleMeau", npermission);
          if (!state.isEverSetStateGeneService) {
            deleteNode(npermission, (listItem: any) => listItem.permissionFlag === "gene_service");
          }
          commit("SET_PERMISSIONLISTNEW", npermission);
          dispatch("GET_PagePermissionListNEW");
          // commit(types.SET_PERMISSIONLOADED, true);
        }
      });
      return pp;
    },
    GET_BUDGET_PERMISSIONLISTNEW({ commit, dispatch, state }: any) {
      const pp = service.getSysMenuByHealthServiceProject({}).then((res: any) => {
        if (res.code == 200 && res.data) {
          console.log("GET_BUDGET_PERMISSIONLISTNEW", state);
          // dispatch("GET_PERMISSIONLISTNEW");
          let reqPermission: any[] = [];
          // const resdata = temPermissions;
          reqPermission = [
            {
              menuName: "社区",
              permissionFlag: "top_community",
              sortNo: 1,
              type: "menu",
              children: res.data,
            },
          ];
          const permission: any[] = [];
          sortTree(reqPermission, permission);
          // console.log("sortTree", permission);
          const npermission = shakeTree(permission);
          controlleMeau(npermission, state);
          if (!state.isEverSetStateGeneService) {
            deleteNode(npermission, (listItem: any) => listItem.permissionFlag === "gene_service");
          }
          commit("SET_PERMISSIONLISTNEW", npermission);
          dispatch("GET_PagePermissionListNEW");
        }
      });
    },
  },
};
export default main;
